<template>
  <div>
    <v-card height="500px" v-if="show_scan_qr === false">
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          height: 500px;
          border: 3px solid grey;
        "
      >
        <v-container fluid>
          <v-row align="center" justify="center">
            <v-col cols="12">
              <!-- Bottone di lettura del QR code -->
              <div class="mr-10" style="display: inline-block">
                <div style="margin-bottom: 10px">
                  <span style="font-weight: bold">QR Code</span>
                </div>
                <div>
                  <v-btn
                    @click="attivaTelecameraQR"
                    elevation="5"
                    height="100px"
                    width="100px"
                  >
                    <v-icon color="black" x-large> mdi-qrcode </v-icon>
                  </v-btn>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-card>

    <!-- Spazio della fotocamera del QR code -->
    <v-card class="pt-5" height="calc(100% - 120px)" v-else>
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col align="center" cols="12">
            <qrcode-stream
              id="qrstream"
              class="qr"
              :camera="camera_qr"
              @decode="onDecodeQR"
            ></qrcode-stream>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" dark @click="chiudiModalQR">Chiudi</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "MultiDataMatrixReader",
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    // Variabili d'appoggio
    camera_qr: "off",

    // Modal
    show_scan_qr: false,

    // Array
  }),
  created() {},
  mounted() {},
  watch: {},
  computed: {},
  methods: {
    attivaTelecameraQR() {
      this.show_scan_qr = true;
      this.camera_qr = "auto";
    },
    chiudiModalQR() {
      this.show_scan_qr = false;
      this.camera_qr = "off";
      this.$emit("clickChiudi");
    },
    onDecodeQR(decodedString) {
      // Seleziono il video del Data Matrix.
      const video = document.querySelector("video");

      /* Preparo il canvas, ne ricavo un context
       * e lo uso per registrare l'immagine. */
      const canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      let ctx = canvas.getContext("2d");
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      const image = canvas.toDataURL("image/jpeg");
      this.$emit("detectQrCode", decodedString, image);
    },
    onResize() {
      this.window_width = window.innerWidth;
    },
  },
};
</script>

<style scoped>
.qr {
  max-width: min(90vw, 500px);
  max-height: min(90vh, 500px);
}
</style>